'use strict';

angular.module('user')
    .component('validateSuccess', {
        templateUrl: 'js/modules/user/components/validate-success/template.html',
    });
